import { TourAttractionsSortable } from '@/components/tours/TourAttractionsSortable';
import { TourPathModeSelector } from '@/components/tours/TourPathModeSelector';
import { type Tour } from '@/config/objects/tours';
import {
  Alert,
  AlertDescription,
  useApiClient,
} from '@startupquickstart/frontend';
import { useQuery } from '@tanstack/react-query';
import { Lock } from 'lucide-react';
import { useParams } from 'react-router-dom';

export function TourAttractionsTab() {
  const { id } = useParams<{ id: string }>();
  const apiClient = useApiClient();

  const { data: tourData } = useQuery<{ success: boolean; data: Tour }>({
    queryKey: ['Tour', id],
    queryFn: () => apiClient.get(`/tours/${id}`),
    enabled: !!id,
  });

  const tour = tourData?.data;
  // User-generated tours are protected from internal modification (the API
  // 403s every stop mutation), so render them read-only with an explanation.
  const isUserTour = Boolean(tour?.ownerId);

  if (!id) return null;

  return (
    <div className="space-y-4 px-4 pb-4">
      {isUserTour && (
        <Alert variant="default" className="border-amber-200 bg-amber-50 text-amber-800">
          <Lock className="h-4 w-4 text-amber-700" />
          <AlertDescription className="text-amber-800">
            This tour was created by a user in the mobile app, so it can't be
            edited from the portal. To offer it as an official tour, create a
            new tour and add the same stops.
          </AlertDescription>
        </Alert>
      )}

      {!isUserTour && (
        <TourPathModeSelector tourId={id} current={tour?.pathMode} />
      )}

      <TourAttractionsSortable
        tourId={id}
        greaterAreaId={tour?.greaterAreaId}
        readOnly={isUserTour}
      />
    </div>
  );
}
